


























import { defineNuxtComponent, computed } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  setup() {
    const {
      state: classifiedSearchState,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    function onResetFiltersButtonClick() {
      classifiedSearchDispatch('clearAll')
    }

    const loadingResults = computed(() => classifiedSearchState.loading.results)

    return {
      loadingResults,
      onResetFiltersButtonClick
    }
  },
  i18n: defineComponentTranslations({
    reset_filters: {
      en: 'Reset filters',
      el: 'Επαναφορά φίλτρων'
    }
  })
})
